import { useQuery } from '@tanstack/react-query';
import { fetchDocumentVariables } from '../services/documentTemplates';
import { documentTemplateKeys } from './documentTemplateKeys';

export const useDocumentVariablesQuery = () =>
  useQuery({
    queryKey: documentTemplateKeys.variables(),
    queryFn: fetchDocumentVariables,
    staleTime: Infinity,
  });
